<div class="www-ord-det-mod">
  <div class="www-ord-det-mod__close">
    <a (click)="closeModal()"><strong></strong>x </a>
  </div>
  <div class="www-ord-det-mod__col">
    <h3 class="www-ord-det-mod__sub-tit">Dziękujemy!</h3>

    <div class="www-ord-det-mod__ord">
      <div class="www-ord-det-mod__ord__text">
        <p>Potwierdzamy Twoją rezerwację miejsca. Spodziewaj się <b>biletu</b> na Twojej skrzynce mailowej.​</p>
      </div>
    </div>
  </div>
</div>
